<script lang="ts">
// A song may appear in both a rail and Fresh drops from the same response.
const reported = new Set<string>()
</script>
<script setup lang="ts">
import { sendSongEvent, type PlaybackContext } from '~/services/songPlayback'
const props = withDefaults(defineProps<{ id: string; context: PlaybackContext; dwell?: number }>(), { dwell: 0 })
const root = ref<HTMLElement | null>(null)
let observer: IntersectionObserver | undefined
let timer: ReturnType<typeof setTimeout> | undefined
let visible = false
let done = false
const cancel = () => { clearTimeout(timer); timer = undefined }
const report = () => {
  if (done || !visible || document.hidden || !props.context.requestId) return
  done = true
  const key = JSON.stringify([props.id, props.context.requestId, props.context.surface])
  if (!reported.has(key)) {
    reported.add(key)
    void sendSongEvent(props.id, 'impression', props.context)
  }
  observer?.disconnect()
}
const schedule = () => { cancel(); if (visible && !document.hidden && !done) { if (props.dwell) timer = setTimeout(report, props.dwell); else report() } }
const connect = () => {
  observer?.disconnect(); cancel(); visible = false
  if (!root.value?.isConnected || done) return
  observer = new IntersectionObserver(entries => {
    const entry = entries[0]
    visible = entry.isIntersecting && entry.intersectionRatio >= .5
    schedule()
  }, { threshold: [.5] })
  observer.observe(root.value)
}
watch(() => [props.id, props.context.requestId, props.context.position], () => { done = false; nextTick(connect) }, { flush: 'post' })
const removeFinish = useNuxtApp().hook('page:finish', connect)
onMounted(() => { connect(); document.addEventListener('visibilitychange', schedule) })
onActivated(connect)
onDeactivated(() => { observer?.disconnect(); cancel() })
onBeforeUnmount(() => { observer?.disconnect(); cancel(); removeFinish(); document.removeEventListener('visibilitychange', schedule) })
</script>
<template><div ref="root" class="list-exposure"><slot /></div></template>
<style scoped>.list-exposure { min-width: 0; }</style>
